export const ON_USER_CHANGE_EVENT_KEY = 'onuserchange';

export function dispatchOnUserChangeEvent() {
  if (typeof document === 'undefined') {
    return;
  }
  document.dispatchEvent(new Event(ON_USER_CHANGE_EVENT_KEY));
}
